<div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="background:url(assets/images/big/auth-bg.jpg) no-repeat center center;">
    <div class="auth-box">
        <div id="loginform">
            <div class="logo">
                <span>
                        <img src="./assets/images/lekha-logo-03.png" style="height: 50px;"alt="logo">   
                             </span>
                <h5 class="font-medium m-b-20">Sign In to CUCURACHA Admin</h5>
            </div>
            <!-- Form -->
            <div class="row">
                <div class="col-12">
                    <form class="form-horizontal mt-3" id="loginform">
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="ti-user"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control form-control-lg"   required #Username="ngModel" name="Username" [(ngModel)]="loginAddObj.userName" placeholder="Email/Mobile Number" aria-label="Username" >
                        </div>
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon2">
                                    <i class="ti-pencil"></i>
                                </span>
                            </div>
                            <input type="password" class="form-control form-control-lg"  required #Password="ngModel" name="Password" [(ngModel)]="loginAddObj.passWord" placeholder="Password" aria-label="Password" aria-describedby="basic-addon1">
                        </div>
                        <div class="form-group row">
                            <div class="col-md-12">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck1">
                                    <label class="custom-control-label" for="customCheck1">Remember me</label>
                                    <a routerLink="/forgetPassword" id="to-recover" class="text-dark float-right">
                                        <i class="fa fa-lock m-r-5"></i> Forgot Password?</a>
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-center">
                            <div class="col-xs-12 p-b-20">
                                <button class="btn btn-block btn-lg bg-gradient-primary text-white"  (click)="login()">Log In
                                </button>
                            </div>
                        </div>

                        <!-- <div class="form-group m-b-0 m-t-10">
                            <div class="col-sm-12 text-center">
                                Don't have an account?
                                <a routerLink="/register" class="text-info m-l-5">
                                    <b>Sign Up
                                    </b>
                                </a>
                            </div>
                        </div> -->
                    </form>
                </div>
            </div>
        </div>

    </div>
</div>